// The hero filmstrip's frames.
//
// THIS FILE IS A MIRROR. The source of truth is Ruby, in
// app/services/order/live_feed.rb: SHOWCASE_TILES holds the service, the
// outward postcode and the alt text for all ten photographs, HERO_ORDER holds
// the strip's frames and the order it uses them in, and
// spec/design/derived_values_spec.rb asserts the two lists match. Change one,
// change the other, or the suite goes red.
//
// It exists in two languages because both renderers need it: the server paints
// the hero before the bundle has run (app/views/gwmc/_hero.html.haml) and
// React paints the identical markup on mount.
//
// `service` and `area` are NOT marketing copy. The caption is the point of the
// whole thing: "Mini Valet, SW18" is a claim stock photography cannot make,
// so it has to be true. Do not invent one.
//
// THERE IS NO HERO_SHOT ANY MORE (2 Nov 2026). From 31 Oct the 01 frame was
// lifted out of this strip to be the fold's one photograph, and it left the
// strip so the same picture did not appear twice on one page. Robin: "put
// barry in the hero instead, high up and then just the 3 wash tiles", so the
// fold's photograph is Barry's cut-out (sections/hero/index.js HeroBarry,
// which owns its own alt and caption) and 01 LEADS THIS STRIP AGAIN, exactly
// as it did before 31 Oct. Nothing is orphaned and nothing is on the page
// twice.
//
// WHAT IS NOT HERE. The strip used to carry 01, 05, 07, 08, 10, 03, 04, 06,
// 09. Four are gone:
//
//   03  FORCED. It was captioned "Ultra Valet, W11" and Ultra Valet has been
//       retired from the catalogue. The caption was true when that wash
//       happened, but a hero cannot advertise a service we do not sell, and
//       relabelling the frame to a service that wash was not would destroy the
//       only thing that makes these photographs better than bought ones.
//       It is a judgement about the HERO. What happens to the same tile in the
//       feed (Order::LiveFeed::SHOWCASE_TILES, which §7.4 reads) is a separate
//       call and it is in the report.
//   04, 06, 09  CHOSEN. They are the three before-and-afters, which the
//       direction itself calls "proof, not hero". The median visitor sees one
//       and a half frames at 390 and two at 1440, so no one ever reached
//       them; §7.4 is a whole section of exactly this proof; and four lazy
//       640 x 853 WebPs are 172 KB of the home page's 600 KB phone
//       budget (DESIGN.md §7).
//
// What is left is five different real postcodes, all work in progress rather
// than a finished car:
//
//   01  an operator in hi-vis, van doors open, kit out, the car under the
//       lance, on a street in SW18. The only frame we own with a person, the
//       van and the work together, which is why it leads.
//   05  snow foam on a Merc against a London brick terrace: foam plus a real
//       postcode in one frame.
//   07  a car under full foam on a cobbled street. Robin called this one out.
//   08  a gloved hand scrubbing an alloy. Real action, a person in frame.
//   10  a gloved hand buffing with a microfibre. Same.
//
// gallery-image-02 is deliberately absent: a flat grey soft-top that reads as
// nothing at size.
//
// All the source files are portrait 640 x 853 and the strip shows them
// portrait. Nothing here is cropped by CSS any more: the band the fold used
// went with HERO_SHOT.

export const HERO_FRAMES = [
  {
    file: 'gallery-image-01.webp',
    service: 'Mini Valet',
    area: 'SW18',
    alt: 'A GoWashMyCar valeter in a hi-vis jacket at work on a foam-covered estate car beside the open doors of the van in Wandsworth'
  },
  {
    file: 'gallery-image-05.webp',
    service: 'Mini Valet PLUS',
    area: 'SE10',
    alt: 'A Mercedes SUV covered in white foam outside a brick terrace in Greenwich'
  },
  {
    file: 'gallery-image-07.webp',
    service: 'Mini Valet',
    area: 'N5',
    alt: 'A car under a full coat of white foam on a cobbled street in Highbury'
  },
  {
    file: 'gallery-image-08.webp',
    service: 'Alloy wheel & tyre deep clean',
    area: 'SW15',
    alt: 'A gloved hand scrubbing the spokes of an alloy wheel in Putney'
  },
  {
    file: 'gallery-image-10.webp',
    service: 'Full Valet',
    area: 'SW19',
    alt: 'A gloved hand buffing a car panel dry in Wimbledon'
  }
]

// The source files are all 640 x 853. Every <img> carries these as width and
// height attributes so the browser reserves the box before the bytes land
// (DESIGN.md §3: no background-image hero, CLS 0.05 or less).
export const FRAME_W = 640
export const FRAME_H = 853

// "Mini Valet, SW18".
export const frameCaption = frame => `${frame.service}, ${frame.area}`
